import { hydra } from '@/lib/services/Hydra'
import useGlobalStore from '@/store/useGlobalStore'

export const useGetReferralCode = () => {
  const {
    setUser,
    app: { alpha2, language },
  } = useGlobalStore()

  const getReferralCode = async ({ refID }: { refID: string }) => {
    try {
      const data = await hydra.getReferralCode({
        country: alpha2,
        language,
        refID,
      })

      if (data && data.items) {
        const refData = data.items[0]

        const nameData = refData?.preferredName ?? refData?.humanName

        setUser({
          customerType: 'Member',
          refID: refData.id.unicity,
          refName: `${nameData.firstName} ${nameData.lastName}`,
          refError: false,
        })

        // TODO: Fetch products again. Once the user has been referred, they become members, and thus they get member pricing.
      } else {
        setUser({ refError: true })
      }
    } catch {
      setUser({ refError: true })
    }
  }
  const getReferralId = async ({ refID }: { refID: string }) => {
    try {
      const data = await hydra.getReferralCode({
        country: alpha2,
        language,
        refID,
      })

      if (data && data.items) {
        const refData = data.items[0]

        return refData
      }
    } catch {
      console.log('error')
    }
    return null
  }
  return { getReferralCode, getReferralId }
}
